export class NcaUrlEvent extends Event {
	public static EVENT_NAME = 'LinkWrapperSelection';

	constructor(
		public ncaUrl: string,
		public originalUrl: string,
		eventInitDict?: EventInit,
	) {
		super(NcaUrlEvent.EVENT_NAME, eventInitDict);
	}
}
